import { formatBudget, formatDateTime } from "../hooks/commonHooks";

const safeToDateIso = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
};

export const normalizeDateStrings = (lead) => {
  const createdIso = safeToDateIso(lead?.created_at);
  const updatedIso = safeToDateIso(lead?.updated_at);

  return {
    // Used for sorting: `useLeadsFilter` does `new Date(lead.date)`.
    date: createdIso ?? updatedIso ?? null,
    // Used for display in the mobile card + expanded desktop row.
    sessionIn: createdIso ? new Date(createdIso).toLocaleString() : "",
    sessionOut: updatedIso ? new Date(updatedIso).toLocaleString() : "",
  };
};

export const normalizeLead = (lead) => {

  if (!lead || typeof lead !== "object") return null;

  const budgetMin = lead.budget_min ?? null;
  const budgetMax = lead.budget_max ?? null;
  // Convert to numbers (or NaN if invalid)
  const min = budgetMin !== null ? Number(budgetMin) : null;
  const max = budgetMax !== null ? Number(budgetMax) : null;

  let budget = null;

  if (min !== null && max !== null && !isNaN(min) && !isNaN(max)) {
    if (min < max) {
      budget = `${formatBudget(min)} - ${formatBudget(max)}`;
    } else {
      budget = formatBudget(min);
    }
  } else if (min !== null && !isNaN(min)) {
    budget = formatBudget(min);
  }

  const lastMessageTime = formatDateTime(lead.session_start);

  // Active channels — drives both the Source column badges and the Source filter
  const sources = [];
  if (lead.is_chat) sources.push("Chat");
  if (lead.is_activity) sources.push("Activity");
  if (lead.is_call) sources.push("Call");

  return {
    // UI expects `id` for `rowKey`.
    id: lead.id ?? lead.lead_id ?? lead.session_id ?? "",


    agent_id:lead.agent_id ?? "",
    agent_name: lead.agent_name ?? "Unknown Agent",
    // Array of active source channels: ["chat"], ["chat", "call"], etc.
    sources,
    name: lead.name ?? "Unknown",
    phone: lead.phone ?? "N/A",
    email: lead.email ?? "N/A",
    crm_pushed: lead.crm_pushed ?? false,

    conversation_time: lead.conversation_time_mins ?? 0,
    category: lead.category ?? "Unknown",

    language_monitoring: lead.language_monitoring ?? "Unknown",

    score: lead.score,
    intent: lead.intent ?? null,

    // UI expects "Property", but the API uses `location` and `property_type`.
    property_name: lead.property_name ?? "N/A",
    property_id:lead.property_id ?? "",
    location: lead.location ?? "N/A",
    unit_type: lead.unit_type ?? "N/A",

    // UI expects "Client", but the API doesn't explicitly expose it in the snippet.
    clientName: lead.name ?? "Unknown Lead",

    summary: lead.summary ?? "",
    activity_summary: lead.activity_summary ?? "",
    chat_activity: lead.activity_events,

    // Extra fields from the API (used by desktop + mobile rendering)
    budget: budget,
    timeline: lastMessageTime,
  };
};

export const normalizeLeads = (leads) => {
  if (!Array.isArray(leads)) return [];
  return leads.map(normalizeLead).filter(Boolean);
};
